/**
 * Tanım satırı — **el** mertebesi: etiket + değer çifti (`<dt>/<dd>`).
 * Bir `<dl>` içinde dizilir; değer rakamsa `rakam` sınıfı hizalı basamak verir.
 * Ölçülen tekrar: aynı bileşen iki dosyada `Satir` adıyla kopyaydı.
 */

export function TanimSatiri({ etiket, deger }: { etiket: string; deger: string }) {
  return (
    <div className="flex flex-col">
      <dt className="text-xs text-[var(--ink-faint)]">{etiket}</dt>
      <dd className="rakam text-sm break-all text-[var(--ink)]">{deger}</dd>
    </div>
  );
}
